import styled, { css } from "styled-components";
import { IStyledComponents } from "../types";
import { ButtonTypes, ButtonSizes } from "./types";

interface StyledButtonProps extends IStyledComponents {
  styleType?: ButtonTypes;
  $size?: ButtonSizes;
  width?: string;
  height?: number;
  bgColor?: string;
  borderColor?: string;
}

export const StyledButton = styled.button<
  StyledButtonProps & React.HTMLProps<HTMLButtonElement>
>`
  background-color: ${({ theme, styleType, disabled, bgColor }) => {
    if (bgColor && theme?.[bgColor]) {
      return theme.colors[bgColor];
    }
    if (disabled) {
      return theme.colors.disabledText;
    }
    switch (styleType) {
      case "secondary":
        return theme.colors.white;
      case "transparent":
      case "secondary-inverted":
        return theme.colors.transparent;
      case "blue":
        return theme.colors.blue;
      case "green":
        return theme.colors.green;
      case "lime-green":
        return theme.colors.green20;
      case "purple-blue":
        return theme.colors.purpleBlue;
      default:
        return theme.colors.primary;
    }
  }};
  border-radius: 8px;
  border: ${({ theme, styleType, borderColor }) => {
    if (styleType === "secondary" || styleType === "secondary-inverted") {
      return `1px solid ${borderColor || theme.colors.graySolid6}`;
    }
    return "0px";
  }};
  color: ${({ theme, styleType, disabled }) => {
    if (styleType === "secondary" && !disabled) {
      return theme.colors.primary;
    }

    return theme.colors.white;
  }};
  box-sizing: border-box;
  text-align: center;
  padding: ${({ height, $size }) => {
    switch ($size) {
      case "xsmall":
        return "4px 12px";
      case "small":
        return "12px 16px";
      default:
        return `${height ? height / 4 : 15}px 32px`;
    }
  }};
  line-height: 10px;
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  ${({ height = 60, $size }) => {
    if ($size) {
      return css`
        height: initial;
      `;
    }
    return css`
      height: ${height}px;
    `;
  }}
  ${({ width }) =>
    width
      ? css`
          width: ${width};
        `
      : null}
  outline: none;
  opacity: initial;

  &:hover {
    ${({ theme, styleType, bgColor }) => {
      if (
        styleType === "primary" ||
        styleType === "blue" ||
        styleType === "secondary-inverted" ||
        styleType === "purple-blue" ||
        (bgColor && theme?.[bgColor])
      ) {
        return css`
          opacity: 0.8;
        `;
      }
      return css`
        background-color: ${({ theme }) => theme.colors.background};
      `;
    }}
  }

  &:active {
    opacity: 0.6;
  }
`;
